<template>
  <div class="section-head">
    <div>
      <p class="eyebrow">{{ eyebrow }}</p>
      <h2>{{ title }}</h2>
    </div>
    <p v-if="description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'SectionHead',
  props: {
    eyebrow: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.section-head {
  display: grid;
  grid-template-columns: minmax(0, 0.75fr) minmax(280px, 0.55fr);
  gap: 44px;
  align-items: end;
  margin-bottom: 36px;

  h2 {
    margin: 0;
    font-size: 40px;
    line-height: 1.16;
    letter-spacing: 0;
  }

  > p {
    margin: 0;
    color: var(--muted);
  }
}

.eyebrow {
  margin: 0 0 8px;
  color: var(--brand);
  font-size: 13px;
  font-weight: 800;
}

@media (max-width: 900px) {
  .section-head {
    grid-template-columns: 1fr;
    gap: 18px;

    h2 {
      font-size: 34px;
    }
  }
}

@media (max-width: 640px) {
  .section-head {
    margin-bottom: 28px;

    h2 {
      font-size: 29px;
    }
  }
}
</style>
